<template>
    <div class="wait-list">
        <div class="wait-opration">
            <el-input placeholder="请输入名称" v-model="queryParams.keywords" prefix-icon="el-icon-search"
                      style="width: 250px"></el-input>
            <el-button style="margin-left: 10px" type="danger" @click="searchNews">搜索</el-button>
            <el-button style="margin-left: 10px" type="danger" @click="deleteRepeatNews">删除API同步的重复数据</el-button>
            <el-select style="float: right" :value="query.language" @change="handleQueryChange('language', $event)"
                       placeholder="请选择">
                <el-option v-for="item in languageList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <div style="float: right;margin-left: 50px">
                <el-select style="float: right;margin-left: 50px" v-model="queryParams.sourceType" placeholder="请选择"
                           @change="searchNews">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="APHA" value="APHA"></el-option>
                    <el-option label="聚合器" value="POLYMER"></el-option>
                    <el-option label="链闻" value="LIAN_WEN"></el-option>
                    <el-option label="金色财经" value="JIN_SE_CAI_JING"></el-option>
                    <el-option label="币世界" value="BI_SHI_JIE"></el-option>
                </el-select>
            </div>
        </div>

        <el-tabs v-model="newsType" @tab-click="handleNewsTypeChange" style="margin-top: 20px">
            <el-tab-pane label="所有" name="ALL"></el-tab-pane>
            <el-tab-pane label="文章" name="ARTICLE"></el-tab-pane>
            <el-tab-pane label="快讯" name="NEWS"></el-tab-pane>
        </el-tabs>

        <div class="wait-list">
            <el-table class="wait-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="newsList" :row-key="() => Math.random()">
                <el-table-column prop="newsTitle" label="标题" min-width="300px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="newsSubtitle" label="副标题/摘要" min-width="300px"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="sourceType" label="数据来源" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.sourceType | formatSourceType}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="300px">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createrName" label="提交人" width="300px"></el-table-column>
                <el-table-column label="操作" width="300px">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="checkNews(scope.row)">查看</el-button>
                        <el-button type="primary" @click="editNews(scope.row)">编辑</el-button>
                        <el-button type="danger" @click="deleteNews(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import '../store';
    import {mapMutations, mapState} from 'vuex';
    import api from '../api';

    export default {
        name: "Wait",
        data() {
            return {
                newsList: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    keywords: "",
                    lang: "",
                    newsType: "",
                    newsStatus: "TO_BE_REVIEWED",
                    sourceType: "",
                    sortType: "1",
                    page: 1,
                    size: 10
                },
                newsType: "ALL",
            }
        },
        computed: {
            ...mapState('cmsManage', ['languageList', 'query'])
        },
        mounted() {

        },
        filters: {
            formatSourceType(state) {
                switch (state) {
                    case 'APHA':
                        return "APHA";
                    case 'LIAN_WEN':
                        return "链闻";
                    case 'JIN_SE_CAI_JING':
                        return "金色财经";
                    case 'POLYMER':
                        return "聚合器";
                    case 'BI_SHI_JIE':
                        return "币世界";
                }
            }
        },
        methods: {
            ...mapMutations('cmsManage', ['changeQuery']),
            handleQueryChange(type, value) {
                this.changeQuery({
                    ...this.query,
                    [type]: value
                });
                this.queryParams.page = 1;
                this.queryParams.lang = value;
                this.getWaitNewsList(this.queryParams);
            },
            handleNewsTypeChange() {
                this.queryParams.page = 1;
                this.queryParams.newsType = this.newsType != 'ALL' ? this.newsType : '';
                this.getWaitNewsList(this.queryParams);
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getWaitNewsList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getWaitNewsList(this.queryParams);
            },
            getWaitNewsList(param) {
                api.getWaitNewsList(param).then(({data}) => {
                    this.newsList = data.records;
                    this.total = data.total;
                });
            },
            searchNews() {
                this.queryParams.page = 1;
                this.getWaitNewsList(this.queryParams);
            },
            checkNews(row) {
                this.$router.push({
                    path: '/cms/manage/review/detail/newsDetail',
                    query: {
                        id: row.id,
                        keywords: this.queryParams.keywords,
                        lang: this.queryParams.lang,
                        newsType: this.queryParams.newsType,
                        newsStatus: this.queryParams.newsStatus,
                        page: this.queryParams.page,
                        size: this.queryParams.size
                    }
                });
            },
            editNews(row) {
                if (row.newsType == "ARTICLE") {
                    this.$router.push({
                        path: '/cms/manage/content/articleSimplify',
                        query: {
                            id: row.id
                        }
                    });
                } else if (row.newsType == "NEWS") {
                    this.$router.push({
                        path: '/cms/manage/content/newsSimplify',
                        query: {
                            id: row.id
                        }
                    });
                }
            },
            deleteNews(row) {
                this.$confirm('确认删除吗？数据将从库中彻底删除！', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteNews({id: row.id}).then(({data}) => {
                        this.getWaitNewsList(this.queryParams);
                        this.$message.success('删除成功！');
                    });
                }).catch(() => {
                });
            },
            deleteRepeatNews() {
                this.$confirm('确认此操作吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteRepeatNews().then(({data}) => {
                        this.getWaitNewsList(this.queryParams);
                        this.$message.success('删除成功！');
                    });
                }).catch(() => {
                });

            }
        },
        created() {
            this.queryParams.lang = this.query.language;
            this.getWaitNewsList(this.queryParams);
        }
    }
</script>

<style type="text/css">
    .wait-list .el-tabs__nav-wrap::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: rgba(245, 249, 255, 0);
        z-index: 1;
    }
</style>
<style lang="less" scoped>
    .wait-list {
        .wait-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
        }
    }
</style>